import { render, staticRenderFns } from "./SliderSlides.vue?vue&type=template&id=19063b90&"
import script from "./SliderSlides.vue?vue&type=script&lang=ts&"
export * from "./SliderSlides.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports